export const filePrefix = 'https://d2f8amc6lmzigh.cloudfront.net/'
